import Vue from "vue";
import Router from "vue-router";
import { AUDITOR_ROLE, RECSHARE_ADMIN_ROLE, ROUTENAME } from "../appConfig";
import About from "@/views/About";
import ChnlAssetMgmt from "@/views/ChnlAssetMgmt";
import DeptAssetList from "@/views/DeptAssetList";
import DeptApprList from "@/views/DeptApprList";
import RecshareApprList from "@/views/RecshareApprList";
import RecShareMemberList from "@/views/RecShareMemberList";
import RecShareSetting from "@/views/RecShareSetting";
//import DeptGrantList from "@/views/DeptGrantList";
//import ChnlGrantList from "@/views/ChnlGrantList";
import GblchnlWhiteList from "@/views/GblchnlWhiteList";
import OrgChannelShare from "@/views/OrgChannelShare";
import OrgAuditList from "@/views/OrgAuditList";
import OrgRecShareList from "@/views/OrgRecShareList";
import ChnlWhiteList from "@/views/ChnlWhiteList";
import RecShareAssetMgmt from "@/views/RecShareAssetMgmt";
import LatestAssetList from "@/views/LatestAssetList";
import {CHNL_ADMIN_ROLE, DEPT_ADMIN_ROLE, GBL_CHNL_ADMIN_ROLE, ORG_ADMIN_ROLE, SYS_ADMIN_ROLE} from "../appConfig";

// System
const GblOrgList = () => import("@/views/GblOrgList");
const OrgDeptList = () => import("@/views/OrgDeptList");
const ChannelList = () => import("@/views/ChannelList");
const ExtChannelList = () => import("@/views/ExtChannelList");
const UserList = () => import("@/views/UserList");
const ResetPwd = () => import("@/views/UserResetPwd");
const OrgMemberList = () => import("@/views/OrgMemberList");
const DeptGroupList = () => import("@/views/DeptGroupList");
const DeptMemberList = () => import("@/views/DeptMemberList");

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views - Pages
const Page404 = () => import("@/views/pages/Page404");
const Page500 = () => import("@/views/pages/Page500");
const Login = () => import("@/views/pages/Login");
const Register = () => import("@/views/pages/Register");

Vue.use(Router);

export default new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
});

function configRoutes() {
  return [
    {
      path: "/",
      redirect: "/about",
      name: ROUTENAME.HOME,
      component: TheContainer,
      children: [
        {
          path: "about",
          name: ROUTENAME.ABOUT,
          component: About,
        },

        {
          path: "global",
          redirect: "/global/orgs",
          name: ROUTENAME.GBL,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "orgs",
              name: ROUTENAME.GBL_ORG,
              component: GblOrgList,
              meta: { roles: [SYS_ADMIN_ROLE] },
            },
            {
              path: "users",
              name: ROUTENAME.GBL_USER,
              component: UserList,
              meta: { roles: [SYS_ADMIN_ROLE] },
            },
            {
              path: "channels",
              name: ROUTENAME.GBL_CHANNEL,
              component: ChannelList,
              meta: { roles: [SYS_ADMIN_ROLE] },
            },
            {
              path: "resetPwd",
              name: ROUTENAME.GBL_RESET_PWD,
              component: ResetPwd,
              meta: { roles: [SYS_ADMIN_ROLE] },
            },
          ],
        },

        {
          path: "gbl-chnl",
          redirect: "/gbl-chnl/assets",
          name: ROUTENAME.GBLCHNL,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "assets",
              name: ROUTENAME.GBLCHNL_ASSET,
              component: ChnlAssetMgmt,
              meta: { roles: [GBL_CHNL_ADMIN_ROLE] },
            },
            {
              path: "whitelist",
              name: ROUTENAME.GBLCHNL_WHITELIST,
              component: GblchnlWhiteList,
              meta: { roles: [GBL_CHNL_ADMIN_ROLE] },
            },
          ],
        },

        {
          path: "org",
          redirect: "/org/depts",
          name: ROUTENAME.ORG,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "users",
              name: ROUTENAME.ORG_USER,
              component: UserList,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "members",
              name: ROUTENAME.ORG_MBR,
              component: OrgMemberList,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "depts",
              name: ROUTENAME.ORG_DEPT,
              component: OrgDeptList,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "channels",
              name: ROUTENAME.ORG_CHNL,
              component: ChannelList,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "extchnls",
              name: ROUTENAME.ORG_EXTCHNL,
              component: ExtChannelList,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "share-chnl",
              name: ROUTENAME.ORG_SHARE_CHNL,
              component: OrgChannelShare,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "recshare",
              name: ROUTENAME.ORG_RECSHARE,
              component: OrgRecShareList,
              meta: { roles: [ORG_ADMIN_ROLE] },
            },
            {
              path: "audit",
              name: ROUTENAME.ORG_AUDIT,
              component: OrgAuditList,
              meta: { roles: [AUDITOR_ROLE] },
            },
          ],
        },


        {
          path: "recshare",
          redirect: "/recshare/members",
          name: ROUTENAME.RECSHARE,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "setting",
              name: ROUTENAME.RECSHARE_SETTING,
              component: RecShareSetting,
              meta: { roles: [RECSHARE_ADMIN_ROLE] },
            },
            {
              path: "members",
              name: ROUTENAME.RECSHARE_MBR,
              component: RecShareMemberList,
              meta: { roles: [RECSHARE_ADMIN_ROLE] },
            },
            {
              path: "assets",
              name: ROUTENAME.RECSHARE_ASSET,
              component: RecShareAssetMgmt,
              meta: { roles: [RECSHARE_ADMIN_ROLE] },
            },
            {
              path: "approve",
              name: ROUTENAME.RECSHARE_APPR,
              component: RecshareApprList,
              meta: { roles: [RECSHARE_ADMIN_ROLE] },
            },
          ],
        },

        {
          path: "dept",
          redirect: "/dept/members",
          name: ROUTENAME.DEPT,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "members",
              name: ROUTENAME.DEPT_MBR,
              component: DeptMemberList,
              meta: { roles: [DEPT_ADMIN_ROLE] },
            },
            {
              path: "groups",
              name: ROUTENAME.DEPT_GRP,
              component: DeptGroupList,
              meta: { roles: [DEPT_ADMIN_ROLE] },
            },
            {
              path: "channels",
              name: ROUTENAME.DEPT_CHNL,
              component: DeptAssetList,
              meta: { roles: [DEPT_ADMIN_ROLE] },
            },
            {
              path: "approve",
              name: ROUTENAME.DEPT_APPR,
              component: DeptApprList,
              meta: { roles: [DEPT_ADMIN_ROLE] },
            },
            {
              path: "latest",
              name: ROUTENAME.DEPT_LATEST,
              component: LatestAssetList,
              meta: { roles: [DEPT_ADMIN_ROLE]},
            }
            //{
              //path: "grant",
              //name: ROUTENAME.DEPT_GRANT,
              //component: DeptGrantList,
              //meta: { roles: [DEPT_ADMIN_ROLE] },
            //},
          ],
        },
        {
          path: "chnl",
          redirect: "/chnl/assets",
          name: ROUTENAME.CHNL,
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "assets",
              name: ROUTENAME.CHNL_ASSET,
              component: ChnlAssetMgmt,
              meta: { roles: [CHNL_ADMIN_ROLE] },
            },
            //{
              //path: "grant",
              //name: ROUTENAME.CHNL_GRANT,
              //component: ChnlGrantList,
              //meta: { roles: [CHNL_ADMIN_ROLE] },
            //},
            {
              path: "whitelist",
              name: ROUTENAME.CHNL_WHITELIST,
              component: ChnlWhiteList,
              meta: { roles: [CHNL_ADMIN_ROLE] },
            },
          ],
        },
      ],
    },
    {
      path: "/pages",
      redirect: "/pages/404",
      name: "Pages",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "404",
          name: "Page404",
          component: Page404,
        },
        {
          path: "500",
          name: "Page500",
          component: Page500,
        },
        {
          path: "login",
          name: "Login",
          component: Login,
        },
        {
          path: "register",
          name: "Register",
          component: Register,
        },
      ],
    },
  ];
}
